/**
 * Google Preview Transformer
 * Transforms WooRank google_preview criteria data into React component-ready format
 */

import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates a scenario-based message for Google Preview
 * @param {Object} data - The Google Preview data object
 * @returns {string|null} - The appropriate message or null if data exists
 */
const generateMessage = (data) => {
  const hasDesktop = data?.desktop?.url || data?.desktop?.title || data?.desktop?.description;
  const hasMobile = data?.mobile?.url || data?.mobile?.title || data?.mobile?.description;
  
  if (!hasDesktop && !hasMobile) {
    return 'The Google Preview was not able to be generated.';
  }
  return null;
};

/**
 * Transforms the google_preview criteria from WooRank API response
 * @param {Object} googlePreviewCriteria - The google_preview criteria object from the API
 * @returns {Object} - Transformed Google Preview data for React components
 */
export const transformGooglePreview = (googlePreviewCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!googlePreviewCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'The Google Preview was not able to be generated.',
      data: null,
    };
  }

  const data = googlePreviewCriteria?.data || {};
  const wooRankStatus = googlePreviewCriteria?.status || 'neutral';
  const importance = googlePreviewCriteria?.importance || 0;
  const solvability = googlePreviewCriteria?.solvability || 0;

  const hasDesktop = data?.desktop?.url || data?.desktop?.title || data?.desktop?.description;
  const hasMobile = data?.mobile?.url || data?.mobile?.title || data?.mobile?.description;
  const isEmpty = !hasDesktop && !hasMobile;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      desktop: hasDesktop ? {
        url: data?.desktop?.url || '',
        title: data?.desktop?.title || '',
        description: data?.desktop?.description || '',
      } : null,
      mobile: hasMobile ? {
        url: data?.mobile?.url || '',
        title: data?.mobile?.title || '',
        description: data?.mobile?.description || '',
      } : null,
    },
  };
};

export default transformGooglePreview;

